import invariant from 'invariant';

import { COUNTRIES, LOCALES } from 'utils/constants';

export function getLocaleName(localeId: string) {
  const locale = LOCALES.find((l) => l.id === localeId);
  invariant(locale, `Invalid locale ID: ${localeId}`);
  return locale.name;
}
export function getCountryName(countryId: string) {
  const country = COUNTRIES.find(({ id }) => id === countryId);
  if (country) return country.name;
  return '';
}
